import {
  Checkbox,
  FormControlLabel,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  formatarTelefone,
  validarEmail,
  validarNome,
  validarTelefone,
} from "../hooks/useInscricaoForm";

// Campos do formulario de inscricao do Grande Encontro do Associativismo,
// compartilhados entre a tela publica (InscricaoPublica) e a tela interna
// da equipe (InscricaoInterna) — recebe o estado inteiro do formulario via
// o hook useInscricaoForm, pra manter os dois formularios em sincronia.
const CamposInscricao = ({ formulario }) => {
  const {
    nome, setNome,
    email, setEmail,
    telefone, setTelefone,
    aceiteLgpd, setAceiteLgpd,
    erros, setErros,
  } = formulario;

  return (
    <Stack spacing={2}>
      <TextField
        label="Nome completo"
        fullWidth
        required
        autoComplete="name"
        value={nome}
        onChange={(e) => setNome(e.target.value)}
        onBlur={() =>
          setErros((prev) => ({
            ...prev,
            nome: validarNome(nome) ? "" : "Digite nome e sobrenome.",
          }))
        }
        error={!!erros.nome}
        helperText={erros.nome}
        inputProps={{ maxLength: 255 }}
      />
      <TextField
        label="E-mail"
        type="email"
        fullWidth
        required
        autoComplete="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onBlur={() =>
          setErros((prev) => ({
            ...prev,
            email: validarEmail(email) ? "" : "E-mail inválido.",
          }))
        }
        error={!!erros.email}
        helperText={erros.email}
        inputProps={{ maxLength: 255 }}
      />
      <TextField
        label="Telefone / WhatsApp"
        fullWidth
        required
        type="tel"
        autoComplete="tel-national"
        placeholder="(11) 99999-9999"
        value={telefone}
        onChange={(e) => setTelefone(formatarTelefone(e.target.value))}
        onBlur={() =>
          setErros((prev) => ({
            ...prev,
            telefone: validarTelefone(telefone) ? "" : "Telefone inválido. Use DDD + número.",
          }))
        }
        error={!!erros.telefone}
        helperText={erros.telefone || "Para avisos de última hora"}
        inputProps={{ inputMode: "numeric", maxLength: 15 }}
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={aceiteLgpd}
            onChange={(e) => setAceiteLgpd(e.target.checked)}
            required
          />
        }
        label={
          <Typography component="span" variant="body2" sx={{ color: "text.secondary" }}>
            Autorizo o uso dos meus dados para comunicações da ACSP.
          </Typography>
        }
      />
    </Stack>
  );
};

export default CamposInscricao;
